const actionPrefix = (actionType) => `PageMessages/${actionType}`;

export const PUSH_PAGE_MESSAGES = actionPrefix`PUSH_PAGE_MESSAGES`;
export const pushPageMessages = (messages) => ({
  type: PUSH_PAGE_MESSAGES,
  payload: messages,
});

export const messagesActions = {
  pushPageMessages,
};
